import { useEffect, useContext } from 'react';
import { RealtimeContext } from '@/lib/realtime/RealtimeProvider';
import type { RealtimeMessage } from '@/lib/realtime/types';

/**
 * Subscribe to a STOMP destination for the lifetime of the calling component.
 */
export function useRealtimeSubscription(
  destination: string | null | undefined,
  onMessage?: (message: RealtimeMessage) => void,
) {
  const ctx = useContext(RealtimeContext);
  const subscribe = ctx?.subscribe;
  const status = ctx?.status ?? 'idle';

  useEffect(() => {
    if (!destination || status !== 'connected' || !subscribe) return;
    return subscribe(destination, onMessage);
  }, [destination, status, subscribe, onMessage]);
}

/**
 * Returns true when WebSocket push is active — use to disable HTTP polling.
 */
export function useRealtimePushActive(): boolean {
  return useContext(RealtimeContext)?.status === 'connected';
}
